import type { FactionId } from "./factions.js";
import type { GateDefinition } from "./world-layout.js";

export const TRAINING = {
  spawn: { x: 10060, y: 1200 },
  transport: { x: 10420, y: 250 },
  enemy: { x: 10630, y: 300 },
  enemyId: "training-raider",
  transportId: "training-transport",
  marker: { x: 10190, y: 1200 },
  practiceTargetId: "training-target",
  telegraphSeconds: 2,
  exits: { x: 10420, y: 1600 },
};
export function trainingCargoId(playerId: string): string {
  return `training-cargo:${playerId}`;
}
export const TRAINING_GATE_FACTIONS: Readonly<Record<string, FactionId>> = {
  "training-to-concord": "concord", "training-to-helion": "helion", "training-to-nomads": "nomads",
};
/** There is no corresponding return gate in a home region. */
export const TRAINING_GATES: readonly GateDefinition[] = [
  { id: "training-to-concord", name: "Телепорт на базу: Содружество", x: 10020, y: 1600, radius: 100, toSectorId: "concord-harmony", destinationX: 460, destinationY: 14100 },
  { id: "training-to-helion", name: "Телепорт на базу: Директорат Гелиона", x: 10420, y: 1740, radius: 100, toSectorId: "helion-rift", destinationX: 3660, destinationY: 14100 },
  { id: "training-to-nomads", name: "Телепорт на базу: Вольные системы", x: 10820, y: 1600, radius: 100, toSectorId: "nomads-last-chance", destinationX: 6860, destinationY: 14100 },
];
